// DOM 綁定，跟純邏輯（email_typo_suggestion.js）分開，方便純邏輯部分
// 用 Jest 直接測試，不需要 mock jQuery/DOM。
var suggestCorrection = require('./email_typo_suggestion.js').suggestCorrection

function bindEmailTypoSuggestion() {
  $('input[type="email"]').each(function () {
    var $input = $(this)

    if ($input.data('email-typo-suggestion-bound')) {
      return
    }
    $input.data('email-typo-suggestion-bound', true)

    var $hint = $('<p class="text-warning email-typo-suggestion" style="margin-top: 5px;"></p>').hide()
    $input.after($hint)

    $input.on('blur', function () {
      var suggestion = suggestCorrection($input.val())

      if (suggestion) {
        $hint.text('你是不是想輸入 ' + suggestion + ' ？').show()
      } else {
        $hint.hide()
      }
    })
  })
}

$(document).ready(bindEmailTypoSuggestion)

export default bindEmailTypoSuggestion



// WEBPACK FOOTER //
// ./app/javascript/packs/bind_email_typo_suggestion.js